import { useEquipment, useDetector } from "@services/servicesGenericsTables";
import { findEquipmentByCode, findDetectorByName } from "../utils/equipmentHelpers";

/**
 * Hook para parsear archivos y mapear datos a equipos/detectores
 */
export const useFileParser = () => {
  const { equipmentList } = useEquipment();
  const { detectorsList } = useDetector();

  /**
   * Parsea los datos del archivo y encuentra los equipos/detectores correspondientes
   */
  const parseAndMapData = (data: any) => {
    const equipment = findEquipmentByCode(equipmentList, data.equipment);
    const detector = findDetectorByName(detectorsList, data.detector);

    return {
      ...data,
      equipment,
      detector,
    };
  };

  /**
   * Mapea los datos parseados a los campos del formulario
   */
  const mapDataToFormFields = (
    parsedData: any,
    equipmentObj?: any,
    detectorObj?: any
  ) => {
    return {
      calculation_date_countig_file: parsedData.date_counting,
      calculation_equipment_file_generic: parsedData.equipment, // Código original del archivo (texto)
      calculation_equipment_file: equipmentObj?.id || equipmentObj, // ID del equipo o el objeto si no tiene ID
      calculation_detectors_generic: parsedData.detector, // Nombre original del archivo (texto)
      calculation_detectors: detectorObj?.id, // ID del detector
      counting_detector: detectorObj ? [detectorObj] : [], // Array de detectores para filtro de calibración
      calculation_time_count: parsedData.time_count,
      calculation_volume: parsedData.volume,
      calibration_source_certificate: parsedData.certificateTrazador,
      calculation_background: parsedData.fondo,
      calculation_calibration: parsedData.calibration,
      calculation_library: parsedData.library,
      calculation_sample: parsedData.sample,
      totalUncertainty: parsedData.totalUncertainty,
      totalActivity: parsedData.totalActivity,
      totalLid: parsedData.totalLid,
      efficiencieTotal: parsedData.efficiencieTotal,
    };
  };

  return {
    parseAndMapData,
    mapDataToFormFields,
    equipmentList,
    detectorsList,
  };
};
